'use client'

import { BookOpenIcon, CheckBadgeIcon, UserIcon } from '@heroicons/react/24/outline'
import { useCompanyContext } from '@/lib/providers/CompanyProvider'
import { useTranslation } from 'react-i18next'

export const BASE_MENU_ITEMS = [
  {
    id: 'my',
    Icon: BookOpenIcon,
    title: 'menu.my',
    href: '/my',
  },
  {
    id: 'application',
    Icon: CheckBadgeIcon,
    title: 'menu.application',
    href: '/my/application',
  },
  {
    id: 'account',
    Icon: UserIcon,
    title: 'menu.account',
    href: '/my/account',
  },
]

export const useMenuItems = () => {
  const { type } = useCompanyContext()
  const { t } = useTranslation('common')

  const filtered =
    type === 'lecture'
      ? BASE_MENU_ITEMS.filter(item => item.id !== 'application')
      : type === 'recruit'
        ? BASE_MENU_ITEMS.filter(item => item.id !== 'my')
        : BASE_MENU_ITEMS

  return filtered.map(item => ({ ...item, title: t(item.title as any) }))
}
